import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { OathService } from 'src/app/_services/oath.service';
import { ErrorUtil } from 'src/app/_utilities/error';

@Component({
  selector: 'app-oauth-credentials',
  templateUrl: './oauth-credentials.component.html',
  styleUrls: ['./oauth-credentials.component.scss'],
  standalone: false
})
export class OauthCredentialsComponent implements OnInit {
  translate: any;
  data: any
  showConsumerKey = false;
  constructor(
     private oathService: OathService,
     private errorUtil: ErrorUtil,
     public modalRef : BsModalRef,
      private languageTranslateService: LanguageTranslateService,
      private spinner: NgxSpinnerService
      
  ) { }

  ngOnInit(): void {
    console.log(this.data)
    this.getLanguageData();
  }
   getLanguageData() {
   this.languageTranslateService.wordSrc$.subscribe(data => { 
      if(Object.keys(data).length != 0){
        this.translate = data
        
      }
    })
    console.log("translate",this.translate)
  }
  /****************************** Get Masked Key *****************************/
getMaskedKey(value: string, showFull: boolean = false, visibleLast = 5): string {
  if (!value) return '-';

  const shouldShow = showFull ? true : this.showConsumerKey; // default uses consumer toggle
  if (shouldShow) return value;

  const maskedLength = Math.max(value.length - visibleLast, 0);
  return '*'.repeat(maskedLength) + value.slice(-visibleLast);
}
getMaskedKey2(value: string, showFull: boolean = false, visibleLast = 5): string {
  if (!value) return '-';

  const shouldShow = showFull ? true : this.showConsumerKey; // default uses consumer toggle
  if (shouldShow) return value;

  const maskedLength = Math.max(value.length - visibleLast, 0);
  return '*'.repeat(maskedLength) + value.slice(-visibleLast);
}

/****************************** Copy Key to Clipboard *****************************/
copyKey(value: string): void {
  if (!value) return;

  navigator.clipboard.writeText(value).then(() => {
    // show toast using your existing ErrorUtil (success style)
    this.errorUtil.setErrorMessage(
      200,
      this.translate?.setup.integrations.oauth.validationFE.keyCopiedSuccessfully,
      null,
      'success',
      1200
    );
  }).catch(() => {
    this.errorUtil.setErrorMessage(
      400,
      null,
      this.translate?.setup.integrations.oauth.validationFE.unableCopyKey,
      'warn',
      2000
    );
  });
}

}
